const _ = require('lodash');

function AgeCalculatorService() { }

AgeCalculatorService.prototype.calculate = function (dateInput) {
    if (_.isUndefined(dateInput) || !_.isString(dateInput)) {
        throw new Error('Date Input is not valid');
    }

    const formatDate = dateInput.split('/');
    const today = new Date();
    const birthDate = new Date(parseInt(formatDate[2]),
        parseInt(formatDate[1]) - 1,
        parseInt(formatDate[0]));

    let yearDiff = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        yearDiff--;
    }
    return yearDiff;
};

module.exports = AgeCalculatorService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/signup/age-calculator-service.js
 **/